import { UNDEFINED_ENUM } from '../../../models/undefined-enum';
import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';
import { z } from 'zod/v4';

export const tollRoadTypeOptions = [
  UNDEFINED_ENUM,
  'AlwaysAvoid',
  'AvoidIfPossible',
  'Use',
] as const;

export const tollRoadTypeSchema = createEnumSchemaPreprocessor(
  z.enum(tollRoadTypeOptions),
  tollRoadTypeOptions
);

export type TollRoadType = z.infer<typeof tollRoadTypeSchema>;
